import React, { Fragment, Component } from 'react'
import axios from 'axios'
import { getApiBaseUrl } from '../utils/api';
import SiteFooter from '../components/SiteFooter';
import { contact, contactPage, hero } from '../content/siteContent';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class ContactUs extends Component {
    
    constructor(){
        super();
        this.state={
            name: '',
            mobileno: '',
            email:'',
            message:''
        }
    }

    onChangeInput = (e) => {
        const re = /^[0-9\b]+$/;
        if(e.target.name === "name"){
          this.setState({
              name: e.target.value
          });
        } else if(e.target.name === "mobileno" && (re.test(e.target.value) || e.target.value === "") && e.target.value.length <= 10){
            this.setState({
                mobileno: e.target.value
            });
         } else if(e.target.name === "email"){
             this.setState({
                email: e.target.value
             });
         } else if(e.target.name === "message"){
             this.setState({
                message: e.target.value
             });
         }
    }
    
    onSendMessage = async () => {
        let enquiryDetail = {
            Name: this.state.name,
            MobileNumber: this.state.mobileno,
            EmailId: this.state.email,
            Message: this.state.message
        };
        if(enquiryDetail.Name.length == 0 || enquiryDetail.MobileNumber.length == 0 || enquiryDetail.EmailId.length == 0){
            toast.warning("Please enter Name, Mobile Number and EmailId");
            return;
        }
        await axios.post(`${getApiBaseUrl()}/hj-enquiry/createContactUsEnq`,enquiryDetail)
            .then((res) => {
                toast.success("Contact us Enquiry saved Successfully! Our executive will contact you as soon as possible.");
                this.clearForm();
            }).catch((error) => {
                console.log(error);
            });
    }
    clearForm = async () =>{
        this.setState({
            name: '',
            mobileno: '',
            email:'',
            message:''
        })
    }
    render(){
        return (
            <Fragment>
                <ToastContainer/>
                <div className="boxed_wrapper ltr">
                    {/* Mobile Menu  */}
                    <div className="mobile-menu">
                        <div className="menu-backdrop"></div>
                        <div className="close-btn"><i className="fas fa-times"></i></div>

                        <nav className="menu-box">
                            <div className="nav-logo"><a href="/"><img src="assets/images/logo-4.png" alt="H.J. Enterprises" title=""/></a></div>
                            <div className="menu-outer">{/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}</div>
                        </nav>
                    </div>{/* End Mobile Menu */}


                    {/* page-title */}
                    <section className="page-title centred">
                        <div className="bg-layer" style={{backgroundImage: "url(assets/images/background/page-title.jpg)"}}></div>
                        <div className="pattern-layer">
                            <div className="pattern-1" style={{backgroundImage: "url(assets/images/shape/shape-18.png)"}}></div>
                            <div className="pattern-2" style={{backgroundImage: "url(assets/images/shape/shape-17.png)"}}></div>
                        </div>
                        <div className="auto-container">
                            <div className="content-box">
                                <h1>{contactPage.heading}</h1>
                            </div>
                        </div>
                    </section>
                    {/* page-title end */}

                    {/* about-style-two */}
                    <section className="about-style-two pt_30 pb_10">
                        <div className="auto-container">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                                    {/* contact-info-section */}
                                    <section className="contact-info-section centred pt_20 pb_50">
                                        <div className="auto-container">
                                            <div className="row clearfix">
                                                <div className="col-lg-12 col-md-6 col-sm-12 info-column">
                                                    <div className="info-block-one wow fadeInUp animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                                                        <div className="inner-box">
                                                            <div className="icon-box"><i className="icon-2"></i></div>
                                                            <h3>Our Location</h3>
                                                            <p>{contact.location}<br/>{hero.partner}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12 info-column">
                                                    <div className="info-block-one wow fadeInUp animated" data-wow-delay="300ms" data-wow-duration="1500ms">
                                                        <div className="inner-box">
                                                            <div className="icon-box"><i className="icon-43"></i></div>
                                                            <h3>Email Address</h3>
                                                            <p>
                                                                <a href={contact.emailMailto}>{contact.email}</a>
                                                                <br />
                                                                <a href={contact.emailSecondaryMailto}>{contact.emailSecondary}</a>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12 info-column">
                                                    <div className="info-block-one wow fadeInUp animated" data-wow-delay="600ms" data-wow-duration="1500ms">
                                                        <div className="inner-box">
                                                            <div className="icon-box"><i className="icon-44"></i></div>
                                                            <h3>Phone Number</h3>
                                                            <p>{contactPage.looking}<br/><a href={contact.phoneTel}>{contact.phone}</a></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    {/* contact-info-section end */}
                                </div>

                                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                                    <section className="faq-form-section pt_10 pb_50">
                                        <div className="auto-container" id="register-form-contactus">
                                            <div className="sec-title mb_10 centred">
                                                <h2>{contactPage.talk}</h2>
                                            </div>
                                            <div className="form-inner">
                                                <div className="row clearfix">
                                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                                        <input 
                                                            type="text" 
                                                            name="name" 
                                                            placeholder="Your name" 
                                                            required=""
                                                            onChange={this.onChangeInput}
                                                            value={this.state.name}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                        <input type="text" 
                                                            name="mobileno" 
                                                            placeholder="Mobile Number" 
                                                            required=""
                                                            onChange={this.onChangeInput}
                                                            value={this.state.mobileno}
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                                        <input 
                                                            type="email" 
                                                            name="email" 
                                                            placeholder="Your email" 
                                                            required=""
                                                            onChange={this.onChangeInput}
                                                            value={this.state.email}
                                                        />
                                                    </div>
                                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                                        <textarea 
                                                            name="message" 
                                                            placeholder="Type message"
                                                            onChange={this.onChangeInput}
                                                            value={this.state.message}
                                                        ></textarea>
                                                    </div>
                                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn centred">
                                                        <button type="submit" className="theme-btn btn-one" onClick={this.onSendMessage}>Send Message</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>

                            </div>
                        </div>
                    </section>
                    {/* about-style-two end */}

                    {/* google-map-section */}
                    <section className="google-map-section pb_20">
                        <div className="auto-container">
                            <iframe title="googleMap" src="https://maps.google.com/maps?q=Goregaon%20West%20Mumbai&t=&z=13&ie=UTF8&iwloc=&output=embed" width="600" height="400" frameBorder="0" style={{border:"0", width: "100%"}} allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>
                        </div>
                    </section>
                    {/* google-map-section end */}



                    {/* main-footer */}
                    <SiteFooter />
                    {/* main-footer end */}

                    {/*Scroll to top*/}
                    <div className="scroll-to-top">
                        <div>
                            <div className="scroll-top-inner">
                                <div className="scroll-bar">
                                    <div className="bar-inner"></div>
                                </div>
                                <div className="scroll-bar-text">Go To Top</div>
                            </div>
                        </div>
                    </div>
                    {/* Scroll to top end */}

                </div>
                
            </Fragment>
        )
    }
}

export default ContactUs;